import type { PushPlatform } from '@/features/push-credentials';

export const PUSH_PLATFORM_ROUTES = {
  ios: '/workspaces/$workspaceId/settings/actions/push/ios',
  android: '/workspaces/$workspaceId/settings/actions/push/android',
} as const satisfies Record<PushPlatform, string>;

export const MOBILE_APPS_PATH = '/workspaces/:workspaceId/settings/actions/apps';
